import { createContext, ReactNode, useContext, useState } from "react";

export type ViewportContextValue = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
};

const ViewportContext = createContext<ViewportContextValue | undefined>(undefined);

function useMediaQuery(query: string): boolean {
  const [matches] = useState(() => (window.matchMedia ? window.matchMedia(query).matches : false));

  // TODO: We need to lock users into their viewport. Commenting out for now until we get feedback
  // that this is the behavior we want or will just need to write more bespoke code
  // useEffect(() => {
  //   const media = window?.matchMedia?.(query);
  //   setMatches(media?.matches ?? false);

  //   const listener = () => setMatches(media?.matches ?? false);
  //   media?.addEventListener("change", listener);

  //   return () => media?.removeEventListener("change", listener);
  // }, [query]);

  return matches;
}

type ViewportProviderProps = {
  children: ReactNode;
  testValues?: ViewportContextValue;
};

export function ViewportProvider({ children, testValues }: ViewportProviderProps) {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 1023px)");
  const isDesktop = useMediaQuery("(min-width: 1024px)");

  return (
    <ViewportContext.Provider value={{ isMobile, isTablet, isDesktop, ...testValues }}>
      {children}
    </ViewportContext.Provider>
  );
}

export function useViewport(): ViewportContextValue {
  const context = useContext(ViewportContext);
  if (!context) {
    throw new Error("useViewport must be used within ViewportProvider");
  }
  return context;
}
